<template>
    <div id="topBar-rebrand" v-if="!isProfileView">
        <div class="advertise-section" v-if="!currentUser">
            <img class="d-md-none" src="/images/document-gradient.svg" alt="Document" width="24"
                 height="25"/>

            <div class="advertise-section--content">
                <a :href="regionRelativeUrl('/users/registration/')"
                   class="btn-v2 btn-v2-outline-white">{{ translate.home.advertiseForFree }}</a>
                <span class="d-none d-md-block">{{ translate.home.createProfileForFree }}</span>
            </div>

            <a :href="regionRelativeUrl('/users/registration/')" class="arrow d-md-none">
                <icon-component class="d-md-none" :icon="fa_arrow_right()" width="19px" height="19px"/>
            </a>
        </div>
        <div class="region-section" :class="{'w-100': currentUser}">
            <RebrandRegionSelectorComponent></RebrandRegionSelectorComponent>

            <select-box-component v-if="isLanguageNeeded"
                                  v-model="selectedLanguage"
                                  :options="languages"
                                  name="language"
                                  :title="translate.home.language"
                                  :description="translate.home.languageDescription"
                                  triggerClass="custom-dropdown-button"
                                  class="cursor-pointer"
                                  type="link"
            >
                <template #triggerIcon>
                    <icon-component :icon="fa_globe_americas()" width="16px" height="16px"/>
                </template>
            </select-box-component>
        </div>
    </div>
</template>

<script>
import SelectBoxComponent from "@/components/partials/SelectBoxComponent.vue";
import {mapState} from "vuex";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_arrow_right, fa_globe_americas} from "@/core/constants/icons";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import RebrandRegionSelectorComponent from "@/components/global/RebrandRegionSelectorComponent.vue";

const data = () => {
    return {
        store: $store,
    }
}

/**
 * On profile pages the whole top bar is hidden,
 * mirroring the nuxt defaultProfile layout which has no TopBar.
 */
function isProfileView() {
    const seoView = _.get(this.store.state, 'seoView');

    if (seoView) {
        return seoView === 'profile';
    }

    return !!this.store.getters.getPreFetchedUser;
}

function created() {
    const regionPath = process.env.MIX_REGION_PATH
    if (regionPath) {
        this.selectedRegionIso = regionPath;
    }
}

function onRegionChange(regionIso) {
    setCookie(cookiesEnum.REDIRECT_TO_REGION_OVERRIDE, regionIso);

    let url = `/${regionIso}/`;

    if (regionIso === regionIsoEnum.GERMANY) {
        url = '/';
    }

    window.location.href = url;
}

async function onLanguageChange(locale) {
    const language = _.get(this, 'settings.languages', []).find(lang => lang.locale === locale);

    const [err, response] = await to(
        api.locale.change(locale)
    )

    const translate = _.get(response, 'data.translate');
    if (err || !translate) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.store.commit('setTranslate', translate);
    this.store.commit('setLocale', locale);
    this.store.commit('setRegionData', _.get(response, 'data.regionData'));

    const key = `navbar_language_${_.toLower(language.name)}`;

    if (typeof wpwlOptions !== "undefined") {
        wpwlOptions.locale = locale;
    }

    this.captureTrackingEvent(this.currentUser, 'language_selector', 'selected', key);
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'settings', 'locale', 'currentUser', 'regionData']),
        isProfileView,
        isLanguageNeeded() {
            return !_.has(this.regionData, 'sectionsToHide.languageSelector');
        },
        regions() {
            return [
                {
                    label: 'Österreich',
                    value: regionIsoEnum.AUSTRIA,
                    link: `/${regionIsoEnum.AUSTRIA}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.AUSTRIA)
                },
                {
                    label: 'Australia',
                    value: regionIsoEnum.AUSTRALIA,
                    link: `/${regionIsoEnum.AUSTRALIA}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.AUSTRALIA)
                },
                {
                    label: 'Deutschland',
                    value: regionIsoEnum.GERMANY,
                    link: `/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.GERMANY)
                },
                {
                    label: 'United Kingdom',
                    value: regionIsoEnum.UNITED_KINGDOM,
                    link: `/${regionIsoEnum.UNITED_KINGDOM}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.UNITED_KINGDOM)
                },
                {
                    label: 'Italia',
                    value: regionIsoEnum.ITALY,
                    link: `/${regionIsoEnum.ITALY}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.ITALY)
                },
                {
                    label: 'Brasil',
                    value: regionIsoEnum.BRAZIL,
                    link: `/${regionIsoEnum.BRAZIL}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.BRAZIL)
                },
            ];
        },
        languages() {
            const languages = this.settings.languages;
            return languages ? languages.map((lang) => {
                return {
                    label: lang.localName,
                    value: lang.locale
                }
            }) : [];
        },
        selectedLanguage: {
            get() {
                return this.locale;
            },
            set(value) {
                this.onLanguageChange(value);
            },
        },
    },
    methods: {
        fa_globe_americas,
        regionRelativeUrl,
        fa_arrow_right,
        onLanguageChange
    },
    mixins: [
        xtrackingMixin
    ],
    components: {RebrandRegionSelectorComponent, IconComponent, SelectBoxComponent},
}
</script>
